import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { Modal, Button, Alert } from 'react-bootstrap';
import is from 'is_js';
import * as moment from 'moment';
import * as settings from '../globals/settings'
import * as digitalIdApi from '../api/digitalIdApi'
import Footer from '../components/footer'
import HelpInfo from '../components/helpInfo'
import { validatePassword } from '../util/validation'
import queryString from 'query-string';

import ReactGA from 'react-ga'

import { doResetPasswordThunk, setFakeLoginState, fakeAuth } from '../actions/auth'
import Loading from '../components/loading'

// FIXME Remove
import { fakeUser, fakeLabResults } from '../util/fakeData'
import { setUser, receiveLabResults, setErrorState, createDeviceId } from '../actions/api'

import NavBar from '../components/navbar'

import '../css/styles.css';

class ForgotPasswordScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isResetPassError: false,
            passwordResetErrorMessage: null,
            newPassword: null,
            confirmNewPassword: null,
            errCode: null,
            errors: {
                newPassword: null,
                confirmPassword: null,
            },
        }
    }
    componentDidUpdate(prevProps, prevState){
        if(this.props.strings !== prevProps.strings && prevState.errCode === this.state.errCode && prevState.errCode !== null){
            if(this.state.errCode === 'IIE'){
                this.setState({isResetPassError: true, passwordResetErrorMessage: this.props.strings.REG_ERROR_INVALID_ITEM});
            } else if(this.state.errCode === 'IPE'){
                this.setState({isResetPassError: true, passwordResetErrorMessage: this.props.strings.REG_ERROR_INVALID_PASSWORD});
            } else if(this.state.errCode === 'ALO'){
                this.setState({isResetPassError: true, passwordResetErrorMessage: this.props.strings.ACCOUNT_LOCKED_MESSAGE});
            } else if(this.state.errCode === 'UNF'){
                this.setState({isForgotError: true, forgotPasswordErrorMessage: this.props.strings.USER_NOT_FOUND_MESSAGE});
            } else if(this.state.errCode === 'MNSE'){
                this.setState({isResetPassError: true, passwordResetErrorMessage: this.props.strings.RESET_PASS_UE_MESSAGE});
            } else if(this.state.errCode === 'UE'){
                this.setState({isResetPassError: true, passwordResetErrorMessage: this.props.strings.RESET_PASS_UE_MESSAGE});
            }
        }
    }

    getUrlParams() {
        let params = queryString.parse(this.props.location.search);
        return { token: params.token };
    }

    handleNewPassword = (e) => {
        let err = this.state.errors;
        err.newPassword = null;
        let val = e.target.value.trim();
        if (validatePassword(val)) {
            this.setState({newPassword: val, errors: err});
        } else {
            err.newPassword = this.props.strings.REG_ERROR_INVALID_PASSWORD;
            this.setState({newPassword: e.target.value, errors: err});
        }
    }

    handleConfirmPassword = (e) => {
        let err = this.state.errors;
        err.confirmPassword = null;
        let val = e.target.value.trim();
        if (this.state.newPassword !== val) {
            err.confirmPassword = this.props.strings.REG_ERROR_PASSWORD_MISMATCH;
            this.setState({confirmNewPassword: val, errors: err});
        } else {
            this.setState({confirmNewPassword: e.target.value, errors: err});
        }
    }

    renderResetPassError() {
        if (this.state.isResetPassError === false || this.state.passwordResetErrorMessage === null) {
            return null;
        } else {
            return (
                <div>
                    <span style={{color: 'red'}}>{this.state.passwordResetErrorMessage}</span>
                </div>
            );
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        console.log(this.state);
        this.setState({isResetPassError: false, passwordResetErrorMessage: null});
        let token = this.getUrlParams();
        this.props.dispatch(doResetPasswordThunk(this.state.newPassword, this.state.confirmNewPassword, token))
            .then(() => {
                this.setState({ showModal: true });
            })
            .catch(err => {
                if(err.code === 'IIE'){
                    this.setState({isResetPassError: true, passwordResetErrorMessage: this.props.strings.REG_ERROR_INVALID_ITEM, errCode: err.code});
                } else if(err.code === 'IPE'){
                    this.setState({isResetPassError: true, passwordResetErrorMessage: this.props.strings.REG_ERROR_INVALID_PASSWORD, errCode: err.code});
                } else if(err.code === 'ALO'){
                    this.setState({isResetPassError: true, passwordResetErrorMessage: this.props.strings.ACCOUNT_LOCKED_MESSAGE, errCode: err.code});
                } else if(err.code === 'UNF'){
                    this.setState({isForgotError: true, forgotPasswordErrorMessage: this.props.strings.USER_NOT_FOUND_MESSAGE, errCode: err.code});
                } else if(err.code === 'MNSE'){
                    this.setState({isResetPassError: true, passwordResetErrorMessage: this.props.strings.RESET_PASS_UE_MESSAGE, errCode: err.code});
                } else {
                    this.setState({isResetPassError: true, passwordResetErrorMessage: this.props.strings.RESET_PASS_UE_MESSAGE, errCode: err.code});
                }
            });;
    }

    handleCancel = (e) => {
        e.preventDefault();
        this.props.history.push("/");
    }

    // FIXME Not sure what should go here?
    renderError(key) {
        if (this.state.errors[key])  {
            return (
                <div className="invalid-feedback">{this.state.errors[key]}</div>
            );
        } else {
            return null;
        }
    }

    renderErrorClass(key) {
        let c = "form-control";
        if (this.state.errors[key])  {
            c = "form-control is-invalid";
        }
        return c;
    }

    renderModal(){
        return (
            <Modal
                className="Modal positionModal"
                show={this.state.showModal}
                centered={true}
                scrollable={true}
                onHide={() => this.setState({ showModal:false })}
            >
                <Modal.Header>
                    <Modal.Title>
                        {this.props.strings.RESET_PASSWORD_LABEL}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.strings.RESET_PASS_CONFIRM_MESSAGE}
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-end">
                        <Button onClick={ () => this.props.history.push("/") } variant="outline-success">
                            {this.props.strings.LOGIN_LABEL}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        } else if (this.props.isLoadingChangePassword === true) {
            return <Loading />
        }

        return (
            <div className="container-full">
                <NavBar language={this.props.language}/>
                {this.renderModal()}
                <div className="container justify-content-center align-items-center">
                    <div class="alert alert-info" role="alert">
                        <h4>{this.props.strings.RESET_PASSWORD_LABEL}</h4>
                        <p>{this.props.strings.FORGOT_PASS_LABEL} <Link to="register">{this.props.strings.REGISTER_NOW_LABEL}</Link> </p>
                    </div>
                    {this.renderResetPassError()}
                    <form onSubmit={this.handleSubmit} className="formMargin">
                            <div class="form-group">
                                <HelpInfo helpInfoText={this.props.strings.HELP_FIELD_PASSWORD} labelText={this.props.strings.PASSWORD_REG_LABEL} />
                                <input class={this.renderErrorClass('newPassword')} type="password" id="new-password-input" placeholder={this.props.strings.NEW_PASSWORD} onChange={this.handleNewPassword}/>
                                {this.renderError('newPassword')}
                            </div>
                            <div class="form-group">
                                <label for="confirm-password-input"><b>{this.props.strings.CONFIRM_PASSWORD_LABEL}</b></label>
                                <input class={this.renderErrorClass('confirmPassword')} type="password" id="confirm-password-input" placeholder={this.props.strings.PASSWORD} onBlur={this.handleConfirmPassword}/>
                                {this.renderError('confirmPassword')}
                            </div>
                            <div className="row justify-content-center">
                                <button type="submit" class="btn btn-primary custom-button" >{this.props.strings.SUBMIT_BUTTON_LABEL}</button>
                            </div>
                            <div className="row justify-content-center">
                                <button type="button" class="btn btn-link" onClick={this.handleCancel} >{this.props.strings.CANCEL_BUTTON_LABEL}</button>
                            </div>
                        </form>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authorizeUrl: state.auth.authorizeUrl,
        isLoadingLogin: state.auth.isLoadingLogin,
        isLoadingRegister: state.auth.isLoadingRegister,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isChangedError: state.auth.isChangedError,
        isResetPassError: state.auth.isResetPassError,
        isForgotError: state.auth.isForgotError,
        strings: state.language.strings,
        isError: state.api.isError,
    }
}

const ConnectedForgotPasswordScreen = connect(
    mapStateToProps
)(ForgotPasswordScreen);

export default withRouter(ConnectedForgotPasswordScreen);